export default __webpack_public_path__ + "static/media/CarDetailing.7681041d.webp";